export default __webpack_public_path__ + "static/media/CertificationIcon.9f58f74d.svg";